import { onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { usePoliticalActions } from './usePoliticalActions'
// import { usePoliticalActionDialog } from './usePoliticalActionDialog'
import { useNotifications } from '@/services/notification/useNotifications'
import { useLogs } from '@/services/useLogs'
import { useTopData } from '@/services/useHome'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import axios from '@/axios'
import dayjs from 'dayjs'

const tabs = reactive([
  {
    name: '経費',
    required: true,
    status: 0,
    fields: ['memoryItems'],
  },
])

export const useMemoryFormTabs = () => {
  return { tabs }
}

export const useMemoryForm = () => {
  const { currentPoliticalAction } = usePoliticalActions()
  const { getNotificationsAfterResponse } = useNotifications()
  const { getTimelineAfterResponse } = useLogs()
  const { getTopDataAfterResponse } = useTopData()
  // const { activityDialog } = usePoliticalActionDialog()
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const route = useRoute()

  onMounted(() => {
    // TODO
    // 1   ・・・青チェック
    // -1  ・・・バリデーションエラー
    // -10 ・・・差し戻しあり
    const status =
      currentPoliticalAction.memory.sentBackItems.length === 0 ? 1 : -10
    setTabStatus(0, status)
  })

  const setTabStatus = (tabIndex, status) => {
    tabs[tabIndex].status = status
  }

  const getSentBackItemMessage = attr => {
    const sentBackList = []
    if (
      currentPoliticalAction.memory.option.viewType === 0 ||
      currentPoliticalAction.memory.option.viewType === 1 ||
      currentPoliticalAction.memory.sentBackItems.length == 0
    ) {
      return []
    }
    currentPoliticalAction.memory.sentBackItems.forEach(item => {
      if (!item || item.length == 0) return []
      const backItem = item.items.find(item => item.target == attr)
      if (backItem !== undefined) {
        sentBackList.push(backItem)
      }
    })
    if (sentBackList.length > 0) {
      sentBackList
      return sentBackList
    }
    return []
  }

  const submitActivity = async (id, type) => {
    try {
      toggleShowLoader(true)
      // validate
      if (!(typeof id === 'number' && id > 0)) {
        throw new Error('invalid id: ' + id)
      }

      if (!(type === 'memory' || type === 'memory-apply')) {
        throw new Error('invalid type: ' + type)
      }

      // create parameter
      const isTemporary = type === 'memory'
      const documentType = 5
      let payload = {
        is_temporary: isTemporary,
        document_type: documentType,
      }

      payload.memory = {
        expenses: currentPoliticalAction.memory.expenses,
      }

      payload.memory.expenses = payload.memory.expenses.map(el => {
        const receipt =
          typeof el.receipt.expenseItem === 'undefined'
            ? {
                // 新規作成の場合
                expense_type_id: el.receipt.expenseTypeId,
                expense_amount: el.receipt.expenseAmount,
                is_distributed: el.receipt.isDistributed,
                numerator: el.receipt.numerator,
                denominator: el.receipt.denominator,
                expense_date: dayjs(el.receipt.expenseDate).format(
                  'YYYY-MM-DD',
                ),
                expense_content1: el.receipt.expenseContent1,
                expense_content2: el.receipt.expenseContent2,
                images: el.receipt.images,
              }
            : {
                // 新規作成ではない場合
                id: el.receipt.expenseItem[0].id,
                expense_type_id: el.receipt.expenseTypeId,
                expense_amount: el.receipt.expenseAmount,
                is_distributed: el.receipt.isDistributed,
                numerator: el.receipt.numerator,
                denominator: el.receipt.denominator,
                expense_date: dayjs(el.receipt.expenseDate).format(
                  'YYYY-MM-DD',
                ),
                expense_content1: el.receipt.expenseContent1,
                expense_content2: el.receipt.expenseContent2,
                images: el.receipt.images,
              }

        const id = el.type[0].id
        return id == 1
          ? {
              // 電車
              type: id,
              from: el.from,
              to: el.to,
              is_round_trip: el.isRoundTrip,
              people: el.people,
              transportation: 1, // TODO (画面未実装のため)
              receipt: receipt,
            }
          : id == 2
          ? {
              // 車
              type: id,
              from: el.from,
              to: el.to,
              is_round_trip: el.isRoundTrip,
              distance: el.distance,
              receipt: receipt,
            }
          : id == 3
          ? {
              // 飛行機
              type: id,
              from: el.from,
              to: el.to,
              is_round_trip: el.isRoundTrip,
              people: el.people,
              transportation: 1, // TODO (画面未実装のため)
              receipt: receipt,
            }
          : id == 4
          ? {
              // 宿泊費
              type: id,
              detail: el.detail,
              receipt: receipt,
            }
          : id == 5
          ? {
              // パック旅行
              type: id,
              from: el.from,
              to: el.to,
              is_round_trip: false,
              people: el.people,
              stay_days: el.stayDays,
              amount: el.amount,
              detail: el.detail,
              transportation: 1, // TODO (画面未実装のため)
              receipt: receipt,
            }
          : id == 6
          ? {
              // その他
              type: id,
              // is_round_trip: false,
              item: el.item,
              detail: el.detail,
              receipt: receipt,
            }
          : null
      })
      // execute
      const response = await axios.put(`/actions/${id}`, payload)
      const { getActivitiesAfterResponse } = usePoliticalActions()
      await getActivitiesAfterResponse(response)
      if (route.name === 'Top') {
        await getTopDataAfterResponse(response)
      } else if (route.name === 'Logs') {
        await getTimelineAfterResponse(response)
      } else if (route.name === 'Notifications') {
        await getNotificationsAfterResponse(response)
      }
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const cancelRequest = async (id, type) => {
    try {
      toggleShowLoader(true)
      const res = await axios.post(`/actions/cancel`, {
        document_id: id,
        document_type: type,
      })
      const { getActivitiesAfterResponse } = usePoliticalActions()
      await getActivitiesAfterResponse(res)
      if (route.name === 'Top') {
        await getTopDataAfterResponse(res)
      } else if (route.name === 'Logs') {
        await getTimelineAfterResponse(res)
      } else if (route.name === 'Notifications') {
        await getNotificationsAfterResponse(res)
      }
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const approveRequest = async (id, type) => {
    try {
      toggleShowLoader(true)
      const res = await axios.post(`/actions/approve`, {
        document_id: id,
        document_type: type,
      })
      const { getActivitiesAfterResponse } = usePoliticalActions()
      await getActivitiesAfterResponse(res)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    submitActivity,
    cancelRequest,
    approveRequest,
    getSentBackItemMessage,
  }
}
